import { useEffect, useState } from "react";
import { TILDA_PATHS } from "../../components/shared/constants";

const useResizeHeightContent = () => {
  const [heightPage, setHeightPage] = useState<null | number>(null);

  useEffect(() => {
    function sendHeightToParent() {
      const findNode = document.querySelector("#portal-modal-container");
      const height = findNode
        ? document.documentElement.scrollHeight
        : document.body.scrollHeight + 1; //  +1 потому что браузер округляет значение scrollHeight за тебя и вероятно не в большюу сторону поэтому в тильде может появляться скрол
      setHeightPage(height);
    }

    const observer = new MutationObserver(function (mutations) {
      sendHeightToParent(); // Отправляем высоту при любом изменении DOM
    });

    const targetNode = document.documentElement; // Или другой элемент, который нужно отслеживать

    const config = { attributes: true, childList: true, subtree: true }; // Отслеживаем все изменения

    observer.observe(targetNode, config);
  }, []);

  useEffect(() => {
    if (heightPage) {
      const message = { height: heightPage, url: window.location.href };
      window.parent.postMessage(message, TILDA_PATHS.reitInvest.tradeIn);
      window.parent.postMessage(message, TILDA_PATHS.reitInvest.reitFacility);
      window.parent.postMessage(message, TILDA_PATHS.reitInvest.ransom);
      window.parent.postMessage(
        message,
        TILDA_PATHS.reitInvest.personalAccount
      );
      window.parent.postMessage(message, TILDA_PATHS.itReit.ransom);
      window.parent.postMessage(message, TILDA_PATHS.itReit.personalAccount);
      window.parent.postMessage(message, TILDA_PATHS.itReit.buy);
      window.parent.postMessage(message, TILDA_PATHS.itReit.sell);
      window.parent.postMessage(message, TILDA_PATHS.itReit.dealService);
      window.parent.postMessage(message, TILDA_PATHS.itReit.tradeIn);
      window.parent.postMessage(message, TILDA_PATHS.itReit.base);
      window.parent.postMessage(message, TILDA_PATHS.reitInvest.base);
    }
  }, [heightPage]);

  return { heightPage };
};

export default useResizeHeightContent;
